import React, { useEffect, useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import Insertfield from "./Insertfield";
import { Typography } from "@mui/material";

/* global console */

export interface ConfirmdialogProps {
  id: string;
  keepMounted: boolean;
  value: any;
  open: boolean;
  tablemode: boolean;
  tablecondition: boolean;
  mainfldid: string;
  onClose: (value?: string) => void;
}

const useStyles = makeStyles({
  root: {
    ".MuiDialogContent-root": {
      padding: "0px 0px 0px 0px !important",
      margin: 0,
    },
    "& .MuiDialog-paperWidthLg": {
      maxWidth: "none !important",
    },
    "& .MuiDialog-paper": {
      margin: 0,
    },
    "& .MuiDialogTitle-root": {
      padding: "1px !important",
      margin: 0,
    },
  },
  content: {
    "&:first-child": {
      padding: 0,
      margin: 0,
    },
  },
});

const Confirmdialog = (props: ConfirmdialogProps) => {
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const classes = useStyles();

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    console.log("Selected value: " + value);
    onClose(value);
  };

  return (
    <>
      <Dialog fullScreen open={open} {...other} className={classes.root}>
        <DialogContent dividers className={classes.content}>
          <Insertfield
            setdlgvalue={setValue}
            title="Select Field"
            mainfldid={props.mainfldid}
            tablemode={props.tablemode}
            tablecondition={props.tablecondition}
            insertmode={false}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="small"
            onClick={handleOk}
            sx={{ bgcolor: "#1C39BB", textTransform: "none" }}
          >
            <Typography sx={{ fontSize: 14 }}>{props.tablemode ? "Add" : "Ok"}</Typography>
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={handleCancel}
            sx={{ bgcolor: "#1C39BB", textTransform: "none" }}
          >
            <Typography sx={{ fontSize: 14 }}>Cancel</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Confirmdialog;
